import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import ModalBox from '../../ui-core/Modal';
import Button from '../../ui-core/Button/Button';
import SubscriptionPlans from './SubscriptionPlans';
import { toggleTrialModal } from '../../store/action/common';
import {
  doFetchProductsRequest,
  doPaymentInitiationRequest,
} from '../../store/action/products';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../constants/app';
import { useParams } from 'react-router';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { encodeBase64Value } from '../../utils/url';
import {
  APP_ROUTES,
  //  getRoute
} from '../../route';
import { useWebsiteSettings } from '../../contexts/WebsiteSettingsContext';

import './PaymentModal.css';

const DEFAULT_TERMS_OF_SERVICE_URL =
  'https://docs.google.com/document/d/1d2nS643SoO95afqaKZtL7EHxClNoACPsiFeqevS7PGQ/edit';

const PaymentFooter = props => {
  const { isLoading, selectedPlan } = useSelector(state => state.product);
  const dispatch = useDispatch();
  const params = useParams();
  const { curatedPlans } = useSelector(state => state.plan);
  const { websiteSettings } = useWebsiteSettings();
  const termsUrl = websiteSettings?.terms_url || DEFAULT_TERMS_OF_SERVICE_URL;
  const privacyUrl = websiteSettings?.privacy_url || APP_ROUTES.PRIVACY_POLICY;
  const privacyHref = privacyUrl.startsWith('http')
    ? privacyUrl
    : `${window.location.origin}${privacyUrl}`;

  // const handleRestorePurchase = () => {
  //   dispatch(toggleTrialModal({ open: false, viewAll: false }));
  //   navigate(//     getRoute(APP_ROUTES.PROFILE_WITH_SUB_ROUTES, {
  //       pathParam: { section: 'payments' },
  //     }), { state: // });
  // };

  const handleSubmit = () => {
    if (!props.showSubscription) {
      trackEvent(SEGMENT_EVENTS.FREE_TRIAL_STARTED, {
        pricing_plan: selectedPlan?.attributes?.name,
        pricing_amount: +selectedPlan?.attributes?.amount_in_cents,
      });
    }
    dispatch(
      doPaymentInitiationRequest({
        page: encodeBase64Value(APP_ROUTES.FREE_TRAIL),
        plan_id: params.id,
      }),
    );
    const curatePlanDetails = {
      title: curatedPlans.title,
      id: curatedPlans.id,
      card_color: curatedPlans.card_color,
    };
    localStorage.setItem(
      'curatePlanDetails',
      JSON.stringify(curatePlanDetails),
    );
  };
  return (
    <>
      <Modal.Footer className="start-free-trail-footer">
        <div className="payment-footer-content w-100">
          <Button
            class="start-free-trail-btn"
            isDisabled={!selectedPlan}
            isLoading={isLoading}
            onClick={handleSubmit}
            text={TEXT_CONSTANT.Get_STARTED}
          />
          <div className="payment-footer-links">
            <a href={termsUrl} target="_blank" rel="noopener noreferrer">
              Terms of Use
            </a>
            {/* <button type="button" onClick={handleRestorePurchase}>
              Restore Purchase
            </button> */}
            <a href={privacyHref} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
PaymentFooter.propTypes = {
  page: PropTypes.string,
  showSubscription: PropTypes.bool,
};

const PaymentModal = () => {
  const { openTrialModal } = useSelector(state => state.common);
  const { open, viewAll, page } = openTrialModal || {};
  const dispatch = useDispatch();

  const toggleViewAll = () => {};

  const renderModalBody = () => {
    return <SubscriptionPlans />;
  };

  const handleClose = () =>
    dispatch(toggleTrialModal({ open: false, viewAll: false }));

  useEffect(() => {
    if (open) {
      dispatch(doFetchProductsRequest());
    }
  }, [open]);

  return (
    <ModalBox
      backButton={false}
      closeButton
      customBackIcon={IMAGE_CONSTANT.backIcon}
      handleClose={handleClose}
      handleGoBack={toggleViewAll}
      dialogClassName={'payment-modal'}
      bsPrefix="payment-modal-wrapper"
      show={open}
      footer={<PaymentFooter page={page} showSubscription={viewAll} />}
    >
      {renderModalBody()}
    </ModalBox>
  );
};

PaymentModal.propTypes = {};

export default PaymentModal;
